(() => {
    HuiNavItemController.$inject = ['$scope'];

    function HuiNavItemController($scope) {
        const self = this;
    }

    angular
        .module("harriApp")
        .directive("huiNavItem", function () {
            return {
                restrict: 'E',
                replace: true,
                scope: true,
                transclude: {
                    badge: '?badge',
                    dropdownItem: '?dropdownItem'
                },
                bindToController: {
                    item: '<',
                    active: '<',
                    highlight: '<',
                    isDropdownExpanded: '<',
                    onMouseenter: '&',
                    onMouseleave: '&',
                    onDropdownToggle: '&',
                    onClick: '&',
                },
                controllerAs: '$ctrl',
                controller: HuiNavItemController,
                templateUrl: `../hmodules/harri-main/ui-components/hui-nav-item.html`
            }
        });
})();